import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../actions";
import { bindActionCreators } from 'redux';

class BetaWelcomeMessage2 extends Component {

	constructor(props) {
		super(props);
	}

	handleHotKey = (e) => {

		if (e.keyCode === 27) {
			e.preventDefault();
			this.closeWindow();
		}
	}

	componentDidMount = () => {
		document.body.style.overflow = 'hidden';
		
		document.querySelector('#uiWindow-layer')?.classList.add('fix-scroll');

		window.addEventListener('keydown', this.handleHotKey)
		
		setTimeout(()=>{
			document.querySelector('#uiWindow-layer').scrollTo(0, 0);
			document.querySelector('[window-name="BetaWelcomeMessage2"]').classList.add('active');
		}, 50)

		document.querySelector('.clickout-layer').addEventListener('click', (e)=>{
			e.preventDefault();
			e.stopImmediatePropagation();
			this.closeWindow();
		})
		
	}

	closeWindow = () => {
		document.querySelector('[window-name="BetaWelcomeMessage2"]').classList.remove('active');
		setTimeout(()=>{
			this.props.removeUIWindow(uiWindow => { 
				return uiWindow.id === 'beta-welcome-message2'
			});
		}, 300)
	}

	componentWillUnmount = () => {
		document.body.style.overflow = '';
		document.querySelector('#uiWindow-layer')?.classList.remove('fix-scroll');
		window.removeEventListener('keydown', this.handleHotKey)
	}

	render() {

		return (
			<div className="info-card">

				{/* <div className="close close-uiWindow">
					<button onClick={()=>{
						localStorage.setItem('betaInfoSeen2', true)
						this.props.removeUIWindow(uiWindow => { 
							return uiWindow.id === 'beta-welcome-message2'
						});
					}}>
						<svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="21" cy="21" r="20" fill="var(--ui-color-flat-reverse)"/>
						<path d="M12.5225 12.522L29.4773 29.4768" stroke="var(--ui-color-flat)" strokeWidth="2"/>
						<path d="M12.5225 29.4775L29.4773 12.5227" stroke="var(--ui-color-flat)" strokeWidth="2"/>
						</svg>

					</button>
				</div> */}

<br/>


			<div className="centered"><svg className="cargositelogo" width="84" height="19" viewBox="0 0 84 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.85203 0C3.96319 0 0 4.2533 0 9.50005C0 14.7467 3.9632 18.9999 8.85203 18.9999H74.9948C79.8836 18.9999 83.8468 14.7467 83.8468 9.50005C83.8468 4.2533 79.8836 0 74.9948 0H8.85203ZM63.5625 4.05077H61.4194L61.8679 1.92424H64.0111L63.5625 4.05077ZM61.4858 13.3875H59.4756L61.2034 5.28016H63.2136L61.4858 13.3875ZM14.2135 10.53C13.8812 12.4405 12.17 13.6865 10.0435 13.6865C7.83393 13.6865 6.40517 12.2744 6.40517 9.98175C6.40517 7.34024 8.14958 5.01435 11.0237 5.01435C13.2665 5.01435 14.5458 6.39327 14.5291 8.56963H12.5688C12.5521 7.47314 12.0537 6.62586 10.9573 6.62586C9.34575 6.62586 8.39878 8.33704 8.39878 9.94855C8.39878 11.261 9.07994 12.0916 10.1432 12.0916C11.1068 12.0916 11.9208 11.4437 12.1368 10.53H14.2135ZM20.0586 12.4571C19.5602 13.1051 18.7295 13.6865 17.5998 13.6865C16.0381 13.6865 14.9416 12.6067 14.9416 11.2277C14.9416 9.41695 16.4701 8.68593 18.1314 8.51979L19.8924 8.33704C20.5902 8.27059 20.856 7.98816 20.856 7.52298C20.856 6.99135 20.3576 6.52617 19.5103 6.52617C18.5966 6.52617 18.065 7.00797 17.9321 7.6725H15.7889C16.0049 6.09422 17.3506 5.01435 19.4439 5.01435C21.7864 5.01435 23.1653 6.22713 22.6503 8.66931L21.6535 13.3875H19.7928L19.8562 13.1336C19.9044 12.9393 19.9677 12.6844 20.0586 12.4571ZM16.9352 11.1779C16.9352 11.8591 17.417 12.1913 18.0816 12.1913C19.1781 12.1913 20.1084 11.2776 20.341 10.2475L20.5238 9.43355C20.3078 9.61625 19.9755 9.68275 19.4439 9.76585L18.7295 9.88205C17.7161 10.0482 16.9352 10.3472 16.9352 11.1779ZM25.3126 13.3875L26.1267 9.53325C26.542 7.58944 27.5886 6.99135 28.7682 6.99135C29.0174 6.99135 29.2168 7.02458 29.3663 7.05781L29.7982 5.0808C29.6819 5.04757 29.4992 5.01435 29.2832 5.01435C28.087 5.01435 27.2231 5.89486 26.6417 6.74215C26.7912 6.42649 26.8909 6.11084 26.9241 5.89486L27.0404 5.28016H25.0302L23.3024 13.3875H25.3126ZM36.5982 13.3376C36.05 15.946 34.7043 17.0757 32.4282 17.0757C30.202 17.0757 28.9062 15.9127 28.9062 13.7198H30.9496C30.9496 14.8827 31.448 15.4808 32.4947 15.4808C33.4749 15.4808 34.2557 14.9159 34.5215 13.7031L34.7209 12.7728C34.7873 12.4239 34.8538 12.1581 34.9701 11.8757C34.372 12.6067 33.6908 13.0884 32.611 13.0884C30.933 13.0884 29.4544 11.8092 29.4544 9.63285C29.4544 7.1741 31.1656 5.01435 33.4416 5.01435C34.9036 5.01435 35.7177 5.6955 36.0832 6.62586C36.0998 6.29359 36.1663 5.87825 36.2493 5.49614L36.2992 5.28016H38.3094L36.5982 13.3376ZM31.4646 9.54985C31.4646 10.6961 32.1458 11.4769 33.1924 11.4769C34.7209 11.4769 35.6845 9.91535 35.6845 8.48657C35.6845 7.43992 35.0365 6.62586 33.9899 6.62586C32.5113 6.62586 31.4646 8.07123 31.4646 9.54985ZM42.3466 13.6865C45.2207 13.6865 47.0316 11.56 47.0316 8.6527C47.0316 6.50956 45.5696 5.01435 43.3932 5.01435C40.5856 5.01435 38.7082 7.1741 38.7082 10.1146C38.7082 12.2744 40.1868 13.6865 42.3466 13.6865ZM42.4795 12.0916C41.3498 12.0916 40.7019 11.3773 40.7019 10.0814C40.7019 8.38688 41.6488 6.62586 43.2603 6.62586C44.3568 6.62586 45.038 7.32362 45.038 8.6527C45.038 10.3306 44.091 12.0916 42.4795 12.0916ZM50.4596 10.9121L49.9279 13.3875H47.4027L47.9343 10.9121H50.4596ZM55.1411 13.6865C57.251 13.6865 58.6299 12.6067 58.6299 10.9785C58.6299 9.69935 57.6165 9.06805 56.4369 8.68593L55.357 8.33704C54.5596 8.08784 54.3602 7.87187 54.3602 7.45653C54.3602 6.89167 54.8752 6.52617 55.6395 6.52617C56.6196 6.52617 57.2177 7.10765 57.2343 8.07123H59.2612C59.2114 6.16068 57.8657 5.01435 55.7391 5.01435C53.6624 5.01435 52.4164 6.11084 52.4164 7.5396C52.4164 8.66931 53.164 9.43355 54.5097 9.86545L55.4567 10.1645C56.2209 10.3971 56.6861 10.5798 56.6861 11.1447C56.6861 11.7428 56.0714 12.1747 55.1909 12.1747C54.1276 12.1747 53.4631 11.4769 53.4631 10.3805H51.4362C51.4362 12.4239 52.865 13.6865 55.1411 13.6865ZM67.0193 13.537C67.4845 13.537 67.8167 13.4706 68.0327 13.3875L68.365 11.8092C68.1822 11.8591 68.0327 11.8757 67.8167 11.8757C66.8698 11.8757 66.5707 11.3773 66.7535 10.4967L67.5177 6.89167H69.4947L69.827 5.28016H67.8666L68.4813 2.35619H66.471L65.8563 5.28016H64.0289L63.68 6.89167H65.5075L64.7432 10.4137C64.3445 12.2744 65.1087 13.537 67.0193 13.537ZM77.0728 10.9785C76.6741 12.5236 75.2453 13.6865 73.1022 13.6865C70.9756 13.6865 69.414 12.2744 69.414 10.015C69.414 7.34023 71.2082 5.01435 74.0491 5.01435C76.591 5.01435 77.8204 6.82522 77.3386 9.38365L77.2555 9.83225H71.4076C71.3245 11.0118 71.8728 12.0916 73.1354 12.0916C74.1322 12.0916 74.6306 11.6597 74.9463 10.9785H77.0728ZM74.0159 6.52617C72.9194 6.52617 72.0057 7.30701 71.7066 8.37027H75.4945C75.6606 7.19071 75.0792 6.52617 74.0159 6.52617Z" fill="white"></path></svg></div>

<br/><br/><div className="centered">SITE BUILDER<br/>
FOR DESIGNERS &amp; ARTISTS<br/>
</div><br/>
<br/>
<br/><h1><ul><li>
Design/publish one or many public sites&nbsp;<br/></li><li>
Real-time, multi-user editing<br/></li><li>
 
One price, no tiers or hidden price stacking<br/></li><li>
 Edit &amp; Publish using the Design Lab™ and the&nbsp;Studio Kit™<br/></li></ul></h1>
<br/>
<br/>
<hr/>
<br/>
<br/>
CARGO is a site builder designed to meet the various needs of creative professionals. There is (of course) <i>single portfolio type use</i> — but you can also design and publish a whole <i>group of sites</i>, each with its own purpose. Simultaneously publish a portfolio, client presentations, idea boards, a profile site, a shop — basically any kind of site you need — all with a single account. We have developed it this way with the budgets of artists and designers in mind.<br/>
<br/>
<br/>
<hr/><br/>
<br/>
<h1>Solo or Multi-User Editing</h1>A site can be built/edited/updated <i>solo</i>, or with (<i>pretty much</i>) any amount of collaborators. That is, you can build/edit/update a site with members of your studio/team or with a client or whomever. All in real-time (think Google Docs with all the design possibilities of Cargo).<br/><br/><br/><h1>Single Site or Multi-Site Publishing</h1>All Cargo accounts allow for having multiple public sites. There is no change in price whether you have 12 sites or 1 site. We hope that it is understood that the decision to develop Cargo this way, is (sincerely) to give artists and designers (and their studios) more power to represent themselves. Being artists and designers ourselves we know that single site representation is simply not enough. Most of us need a portfolio, as well as client presentation sites, idea boards, shops, etc.<br/>
<br/>
<br/>
<h1>Pricing</h1>

There is only one price for Cargo: $14/mo (when billed&nbsp;annually, or $19/mo when billed monthly). No tiers or price stacking.<br/>
<br/>
<ul><li> All accounts have 1 free custom domain connection (connecting additional custom domains is priced at $2/mo when billed yearly or $3/mo when billed monthly).</li><li>
 All accounts have the ability to make unlimited public sites using “cargo.site” domains (as in: site1.cargo.site, site2.cargo.site, site3.cargo.site, etc.) — again this comes with no increase to pricing.<br/></li></ul>
<br/>
<br/>
<h1>The Design Lab™</h1>With the ability to have multiple sites of different purposes, comes the need for a flexible and multifaceted design tool. We are calling this tool/area The Design Lab™.<br/><br/>
The Design Lab is essentially a collection of rows of either <i>templates</i> or <i>design elements</i>. (There are also rows for design-research/inspiration as well as how-to type videos/articles.)<br/><br/>
There are many different styles of templates — from deep portfolio, shops and presentation-type sites, to quick bio/profile, flyer/announcement and drop-shop-type sites.<br/><br/>
The Design Lab was developed with flexibility in mind — flexibility in starting a site and flexibility as to how one can piece together a site. That is, use a template straight away, or assemble (copy/paste) from various design elements, <i>or</i> mix and match (copy/paste design elements into an existing template or site).<br/><br/>
As well, with the Design Lab, a site can <i>pretty much</i> start from anywhere. Even a <i>font specimen </i>can be a starting point from which to build a site. (Note: Most sites and elements have a “duplicate” button).<br/>
<br/><br/>
<h1>The Studio Kit™ (The Multi-Site Concept)</h1>The “Studio Kit” is a concept / model to help a studio / artist / designer develop a multi-site scenario.<br/><br/>
The rows labeled “Studio Kit” are a collection of both dense and lightweight site templates — organized out of the rest of the Design Lab. The idea is to assist studios / artists / designers in getting to <i>multi-site representation</i> faster. To quickly help with simultaneously having a portfolio, client presentations, design boards, shops, etc., etc.<br/>
<br/>
<br/>
<h1>u.cargo™</h1>Lastly, we have a new area, related but outside the Design Lab, called “u.cargo.” This is an overview area to show all of your sites. Within, you have the ability to make folders and organize your many sites and projects.<br/>
<br/>
<br/>
<br/>
<br/>
<hr/><br/>
<div className="centered">Learn more:<br/>
<a href="https://docs.cargo.site" target="_blank">docs.cargo.site</a></div><br/>
<br/>


			</div>
		)

	}

}




function mapDispatchToProps(dispatch) {
	
	return bindActionCreators({
		removeUIWindow: actions.removeUIWindow,
	}, dispatch);

}


export default connect(
	null,
	mapDispatchToProps 
)(BetaWelcomeMessage2)